/*
 * lazy-slider-init.js
 * Defers connectedCallback() of slider custom elements until they are near the viewport.
 * Above-fold and just-below-fold elements init immediately (no behavior change).
 * Far-below-fold elements wait until they enter a 600px rootMargin window.
 *
 * Targets: <grid-slider>, <slideshow-component>
 *
 * Must load BEFORE theme.js and slideshow-component.js (the scripts that define those tags).
 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || !('customElements' in window)) return;

  var SLIDER_TAGS = ['grid-slider', 'slideshow-component'];
  var ROOT_MARGIN = '600px 0px';
  var IMMEDIATE_THRESHOLD = 800;

  var origDefine = customElements.define.bind(customElements);

  customElements.define = function (name, ctor, opts) {
    if (SLIDER_TAGS.indexOf(name) !== -1 && ctor && ctor.prototype && typeof ctor.prototype.connectedCallback === 'function') {
      var origConnected = ctor.prototype.connectedCallback;
      var origDisconnected = ctor.prototype.disconnectedCallback;

      ctor.prototype.connectedCallback = function () {
        var self = this;
        var rect;
        try { rect = this.getBoundingClientRect(); } catch (e) { rect = null; }
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;

        if (!rect || rect.top < vh + IMMEDIATE_THRESHOLD) {
          return origConnected.call(self);
        }

        self.__lazyObserver = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              if (self.__lazyObserver) {
                self.__lazyObserver.disconnect();
                self.__lazyObserver = null;
              }
              origConnected.call(self);
              return;
            }
          }
        }, { rootMargin: ROOT_MARGIN });
        self.__lazyObserver.observe(self);
      };

      ctor.prototype.disconnectedCallback = function () {
        if (this.__lazyObserver) {
          this.__lazyObserver.disconnect();
          this.__lazyObserver = null;
        }
        if (typeof origDisconnected === 'function') {
          return origDisconnected.apply(this, arguments);
        }
      };
    }
    return origDefine(name, ctor, opts);
  };
})();
